import React from "react"
import * as all_footer_components from "../footer-components"

export const getFooterComponent = ({ type, react_key, ...rest }) => {
  const Component = all_footer_components[type]
  return <Component {...rest} key={`footer-component-${react_key}`} />
}
